import React, { Component, Fragment } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Request from '../../utils/request';
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import './style.less';

class PipelineRank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rankList: []
    };
    this.isAndroid = utils.isAndroid();
  }

  componentDidMount(){
    this.getRankList();
  }

  getRankList = async() => {
    const { componentTemplate, rankProductList_layout_more, rankProductList_layout_3, rankCollectList_layout_2, rankCollectList_layout_3 } = this.props.config;
    let itemList = [];
    switch (componentTemplate.templateSelect) {
      case '商品榜单一行多':
        itemList = rankProductList_layout_more;
        break;
      case '商品榜单一行三':
        itemList = rankProductList_layout_3;
        break;
      case '榜单集合一行二':
        itemList = rankCollectList_layout_2;
        break;
      case '榜单集合一行三':
        itemList = rankCollectList_layout_3;
        break;
      default:
        break;
    }

    let rankList = [];

    const createTime = this.props.createTime;
    // 新版排行榜上线时间是 2025-01-23
    if (!createTime || createTime >= 1737561600000) {
      // 页面创建时间在 2025-01-23 00:00:00 之后的，统一读取新排行榜接口
      rankList = await this.getRankListNewApi(itemList);
    } else {
      // 页面创建时间在 2025-01-23 00:00:00 之前的，统一读取老排行榜接口
      rankList = await this.getRankListOldApi(itemList);
    }

    // 插入定制化内容
    rankList.forEach((product) => {
      const customItem = itemList.find((item) => item.id == product.top_id);
      if (customItem) {
        if (customItem.title.trim()) {
          product.top_name = customItem.top_name || customItem.title
        }
        if (['商品榜单一行多'].indexOf(componentTemplate.templateSelect) >= 0) {
          product.titleIconImage = customItem.titleIconImage
        }
        if (['商品榜单一行三'].indexOf(componentTemplate.templateSelect) >= 0) {
          product.titleIconImage = customItem.titleIconImage
          Number(customItem.showNumber) && (product.showNumber = customItem.showNumber)
        }
        if (['榜单集合一行二', '榜单集合一行三'].indexOf(componentTemplate.templateSelect) >= 0) {
          product.benefit = customItem.benefit;
          product.rankImage = customItem.rankImage;
          product.rankTagImage = customItem.rankTagImage;
        }
      }
    });
    
    this.setState({
      rankList
    });
  }
  
  // 获取老排行榜Api
  getRankListOldApi = (itemList) => {
    const idList = itemList.map((item) => {
      return item.id ? item.id : '0';
    });
    return new Promise((resolve) => {
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-goodsinnerapi/api/inner/top/info?access_token=WphjwI564K8kzs5JQZ',
        method: "post",
        withCredentials: true,
        data: {
          topListIds: idList,
        },
      }).then((res) => {
        const { status, data } = res.data;
        if (status === 0) {
          const list = data || [];
          // 老排行榜的字段转换成新排行榜的字段用于渲染
          const rankList = list.map(item => {
            const { id, name, href } = item;
            return {
              top_id: id,
              top_name: name,
              href: href,
              good_list: item.top_detail ? item.top_detail.map(val => {
                const { name, price, sale, pic, goods_id, style_id, href } = val;
                return {
                  good_title: name,
                  price_text: price,
                  sell_number: sale,
                  img: pic,
                  GoodsId: goods_id,
                  StyleId: style_id,
                  Href: href
                }
              }) : []
            }
          });
          resolve(rankList);
        } else {
          resolve([]);
        }
      }).catch(err => {
        resolve([])
      });  
    })
  }
  // 新排行榜接口
  getRankListNewApi = (itemList) => {
    const idList = itemList.map((item) => {
      return item.id ? Number(item.id) : 0;
    });
    return new Promise((resolve) => {
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-topapi/saletop/top-info',
        method: "post",
        withCredentials: true,
        data: {
          topListIds: idList,
        },
      }).then((res) => {
        const { status, data } = res.data;
        if (status === 0 && data) {
          const rankList = data || [];
          resolve(rankList);
        } else {
          resolve([])
        }
      }).catch(err => {
        resolve([])
      });
    });
  }

  // 更多跳转
  handleMoreClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const url = item.href;
    const options = {
      title: item.top_name,
      topic_id: item.top_id,
      sort: index
    };

    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false,{blockName: 'more'});
  }

  // 商品跳转
  handleItemClick = (topic, item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.Href,
        props: this.props,
        index
      })
      return
    }

    const options = {
      title: item.good_title,
      sort: index,
      goods_id: item.GoodsId,
      style_id: item.StyleId,
      topic_id: topic.top_id,
    };
    utils.jumpToUrl(this.props.routeParams, item.Href, item.Href, options, item.GoodsId, this.props);
  }

  productBannerGo = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    // banner跳转
    const options = {};

    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false);

  }

  // 商品榜单一行多
  renderProductLayoutMore() {
    const { rankList } = this.state;
    const { baseConfig, rankProductConfig_layout_more } = this.props.config;
    const { layout = {} } = baseConfig;
    const { rankTitleBgColorType, rankOnlyTitleBg, rankTitleBgColorFrom, rankTitleBgColorTo, rankTitleBg, titleTxtColor, productNameColor,  priceNumColor, priceTxt, priceTxtColor, originalPriceColor, moreTxtBg, rankBgImage, titleBgImage, productBgImage, rankTagTop1, rankTagTop2, rankTagTop3, rankTagCommon, titleImageSize, showSales } = rankProductConfig_layout_more;
    const { width, height } = utils.getAdaptImageSize(titleImageSize);
    const titleStyle = 
      rankTitleBgColorType == "纯色背景"
      ? { backgroundColor: rankTitleBgColorType == "纯色背景" ? rankOnlyTitleBg : 'transparent' }
      : { background: rankTitleBgColorType == "渐变色背景" ? `linear-gradient(180deg, ${utils.hexColorToRgba(rankTitleBgColorFrom, 1)} 0%, ${utils.hexColorToRgba(rankTitleBgColorTo, 1)} 100%), #FFFFFF` : 'transparent' };
    return rankList.map((item, index) => {
      return (
        <div className="rank-product-layout-more" key={`rank-${index}`} style={{ marginBottom: index === rankList.length - 1 ? 0 : `${layout.itemMargin}px`, backgroundColor: rankTitleBg,  backgroundImage: rankBgImage ? `url(${rankBgImage})` : 'none' }} >
          <div className="rank-title" style={{ color: titleTxtColor || '#333', ...titleStyle }}>
            { 
              rankTitleBgColorType == "图片背景" && titleBgImage && (
                <img
                  src={utils.formatImgUrl(titleBgImage, this.props.webpSupport)}
                  alt=""
                  className='title-image'
                />
              ) 
            }
            <div className={`title-content ${rankTitleBgColorType == "图片背景" && titleBgImage ? 'absolute' : 'static'}`}>
              <div className='icon-name'>
                { item.titleIconImage && <img src={item.titleIconImage} alt="" className='icon' /> }
                <p className='name'>{item.top_name}</p>
              </div>
              <div className='more' onClick={this.handleMoreClick.bind(this, item, index)}>
                {
                  (
                    <Fragment>
                      更多
                      <svg t="1658131192314" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1187" className={this.isAndroid ? 'more-icon android' : 'more-icon ios'}>
                        <path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="1188" fill={titleTxtColor || '#333333'}></path>
                      </svg>
                    </Fragment>
                  )
                }
              </div>
            </div>
          </div>
          <div className="goods-body">
            <div className="goods-scroll">
              {
                item.good_list && item.good_list.map((item2, index2) => {
                  if (index2 <= 6) {
                    let rankTagIcon = '', sell_number = '';
                    if (index2 === 0) {
                      rankTagIcon = rankTagTop1 || rankTagCommon
                    } else if (index2 === 1) {
                      rankTagIcon = rankTagTop2 || rankTagCommon
                    } else if (index2 === 2) {
                      rankTagIcon = rankTagTop3 || rankTagCommon
                    } else {
                      rankTagIcon = rankTagCommon
                    }

                    if (showSales) {
                      if (item2.sell_number) {
                        sell_number = item2.sell_number > 9999 ? `月销${(item2.sell_number / 10000).toFixed(1)}w` : `月销${item2.sell_number}`; 
                      } else {
                        sell_number = '爆品热卖';
                      }
                    }

                    return (
                      <div
                        ref={ele => {
                          if (ele) {
                            this.props.exp && this.props.exp(ele);
                          }
                        }}
                        data-dot={JSON.stringify(utils.getExposureData(this.props, {
                          title: item2.good_title,
                          sort: index2,
                          goods_id: item2.GoodsId,
                          style_id: item2.StyleId,
                          topic_id: item.top_id,
                        }))}
                        className="goods-item"
                        key={`goods-${index2}`}
                        style={{
                          backgroundImage: productBgImage ? `url(${productBgImage})` : 'none',
                          border: productBgImage && 'none',
                          backgroundColor: productBgImage && "transparent"
                        }}
                        onClick={this.handleItemClick.bind(this, item, item2, index2)}
                      >
                        { rankTagIcon && <img src={rankTagIcon} alt="" className="rank-tag" /> }
                        <div className="goods-item-img">
                          <LazyLoadImage
                            width={px2rem('104px')}
                            height={px2rem('104px')}
                            effect="opacity"
                            src={utils.formatImgUrl(item2.img, this.props.webpSupport, 'card')}
                          />
                          {
                            showSales && <p className='sales'>{sell_number}</p>
                          }
                          <div className='mask'></div>
                        </div>
                        <p className="goods-item-title" style={{color: productNameColor}}>
                          {item2.good_title}
                        </p>
                        <div className="goods-item-bottom" >
                          <div className={`goods-item-price ${this.isAndroid ? 'android' : 'ios'}`} style={{color: priceNumColor}}>
                            { this.renderPriceDom(item2.price_text) }
                          </div>
                          <p className='sales-num'>
                            月售{item2.sell_number}
                          </p>
                        </div>
                      </div>
                    )
                  }
                })
              }
            </div>
          </div>
        </div>
      )
    })
  }

  // 商品榜单一行三
  renderProductLayoutThree() {
    const { rankList } = this.state;
    const { baseConfig, rankProductConfig_layout_3 } = this.props.config;
    const { layout = {} } = baseConfig;
    let { rankTitleBgColorType, rankOnlyTitleBg, rankTitleBgColorFrom, rankTitleBgColorTo, rankTitleBg, titleTxtColor, productNameColor, benefitTxtColor, showNumber, rankBgImage, titleBgImage, productBgImage, rankTagTop1, rankTagTop2, rankTagTop3, rankTagCommon } = rankProductConfig_layout_3;
    const titleStyle = 
      rankTitleBgColorType == "纯色背景"
      ? { backgroundColor: rankTitleBgColorType == "纯色背景" ? rankOnlyTitleBg : 'transparent' }
      : { background: rankTitleBgColorType == "渐变色背景" ? `linear-gradient(180deg, ${utils.hexColorToRgba(rankTitleBgColorFrom, 1)} 0%, ${utils.hexColorToRgba(rankTitleBgColorTo, 1)} 100%), #FFFFFF` : 'transparent' };
    return rankList.map((item, index) => {
      return (
        <div className="rank-product-layout-three" key={`rank-${index}`} style={{ marginBottom: index === rankList.length - 1 ? 0 : `${layout.itemMargin}px`, backgroundColor: rankTitleBg, backgroundImage: rankBgImage ? `url(${rankBgImage})` : 'none' }} >
          <div className="rank-title" style={{ color: titleTxtColor || '#333' , ...titleStyle}}>
            { rankTitleBgColorType == "图片背景" && titleBgImage && <img src={utils.formatImgUrl(titleBgImage, this.props.webpSupport)} alt="" className='title-image' /> }
            <div className={rankTitleBgColorType == "图片背景" && titleBgImage ? 'title-content absolute' : 'title-content static'}>
              <div className='icon-name'>
                { item.titleIconImage && <img src={item.titleIconImage} alt="" className='icon' /> }
                <p className='name'>{item.top_name}</p>
              </div>
              <div className='more' onClick={this.handleMoreClick.bind(this, item, index)}>
                {
                  (
                    <Fragment>
                      更多
                      <svg t="1658131192314" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="1187" className='more-icon'>
                        <path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="1188" fill={titleTxtColor || '#333333'}></path>
                      </svg>
                    </Fragment>
                  )
                }
              </div>
            </div>
          </div>
          <ul className='rank-body'>
            {
              item.good_list && item.good_list.map((item2, index2) => {
                showNumber =  Number(item.showNumber) || showNumber;
                if (index2 < showNumber) {
                  let rankTagIcon = '';
                  if (index2 === 0) {
                    rankTagIcon = rankTagTop1 || rankTagCommon
                  } else if (index2 === 1) {
                    rankTagIcon = rankTagTop2 || rankTagCommon
                  } else if (index2 === 2) {
                    rankTagIcon = rankTagTop3 || rankTagCommon
                  } else {
                    rankTagIcon = rankTagCommon
                  }
                  return (
                    <div
                      ref={ele => {
                        if (ele) {
                          this.props.exp && this.props.exp(ele);
                        }
                      }}
                      data-dot={JSON.stringify(utils.getExposureData(this.props, {
                        title: item2.good_title,
                        sort: index2,
                        goods_id: item2.GoodsId,
                        style_id: item2.StyleId,
                        topic_id: item.top_id,
                      }))}
                      className="goods-item" key={`goods-${index2}`}
                      style={{
                        backgroundImage: productBgImage ? `url(${productBgImage})` : 'none',
                        border: productBgImage && 'none',
                        backgroundColor: productBgImage && "transparent"
                      }}
                      onClick={this.handleItemClick.bind(this, item, item2, index2)}
                    >
                      { rankTagIcon && <img src={rankTagIcon} alt="" className="rank-tag" /> }
                      <div className="goods-item-img">
                        <LazyLoadImage
                          width={px2rem('92px')}
                          height={px2rem('92px')}
                          effect="opacity"
                          src={utils.formatImgUrl(item2.img, this.props.webpSupport, 'card')}
                        />
                      </div>
                      <p className="goods-item-title" style={{color: productNameColor}}>
                        {item2.good_title}
                      </p>
                      <p className='goods-item-desc' style={{color: benefitTxtColor}}>{item2.description}</p>
                    </div>
                  )
                }
              })
            }
          </ul>
        </div>
      )
    })
  }

  // 集合榜单一行二
  renderCollectLayoutTwo() {
    const { rankList } = this.state;
    const { baseConfig, rankCollectConfig_layout_2 } = this.props.config;
    const { layout = {} } = baseConfig;
    const { rankTitleBg, titleTxtColor, benefitTxtColor, productBgImage, productBtnImage } = rankCollectConfig_layout_2;
    return (
      <div className="rank-collect-layout-two">
        {
          rankList.map((item, index) => {
            return (
              <li
                className='rank-item'
                key={`rank-${index}`}
                style={{ backgroundImage: productBgImage ? `url(${productBgImage})` : `url(//static.shihuocdn.cn/admin/files/20220715/d9c2fb5aaebf9889c7cc3c711321d32b.png)` }}
                onClick={this.handleMoreClick.bind(this, item, index)}
              >
                { item.rankTagImage && <img src={item.rankTagImage} alt="" className='rank-tag' /> }
                <img src={item.rankImage} alt="" className='rank-image' />
                <div className='rank-info'>
                  <p className='rank-title' style={{color: titleTxtColor}}>{item.top_name}</p>
                  <p className='rank-desc' style={{color: benefitTxtColor}}>{item.benefit}</p>
                  {productBtnImage && <img className='rank-btn' src={productBtnImage}></img>}
                </div>
              </li>
            )
          })
        }
      </div>
    )
  }

  // 集合榜单一行三
  renderCollectLayoutThree() {
    const { rankList } = this.state;
    const { baseConfig, rankCollectConfig_layout_3 } = this.props.config;
    const { layout = {} } = baseConfig;
    const { rankTitleBg, titleTxtColor, benefitTxtColor, productBgImage, productBtnImage } = rankCollectConfig_layout_3;
    return (
      <div className="rank-collect-layout-three">
        {
          rankList.map((item, index) => {
            return (
              <li 
                className='rank-item'
                key={`rank-${index}`}
                style={{ backgroundImage: productBgImage ? `url(${productBgImage})` : `url(//static.shihuocdn.cn/admin/files/20220715/6668f880553e31aba9bbe3eeb66cfee0.png)` }}
                onClick={this.handleMoreClick.bind(this, item, index)}
              >
                { item.rankTagImage && <img src={item.rankTagImage} alt="" className='rank-tag' /> }
                <img src={item.rankImage} alt="" className='rank-image' />
                <div className='rank-info'>
                  <p className='rank-title' style={{color: titleTxtColor}}>{item.top_name}</p>
                  <p className='rank-desc' style={{color: benefitTxtColor}}>{item.benefit}</p>
                  {productBtnImage && <img className='rank-btn' src={productBtnImage}></img>}
                </div>
              </li>
            )
          })
        }
      </div>
    )
  }

  renderPriceDom = (price = 0) => {
    let priceDom = null, decimals = '', suffix = '';
    if (price > 9999) {
      price = parseFloat((price / 10000).toFixed(1)) + '万'
    } else {
      price = String(price)
    }
    if (price.indexOf('.') >= 0) {
      price = price.split('.');
    }
    if (Array.isArray(price)) {
      if (price[1] && price[1].indexOf('万') >= 0) {
        decimals = price[1].replace('万', '');
        suffix = '万';
      } else {
        decimals = price[1];
      }
      priceDom = (
        <p className={`price ${this.isAndroid ? 'android' : 'ios'} ${this.isIphone14ProMax ? 'iphone14ProMax' : ''}`}>
          <span className="symbol">¥</span>
          {price[0]}.
          <span className="decimals">{decimals}</span>
          <span className="suffix">{suffix}</span>
        </p>
      )
    } else {
      if (price.indexOf('万') >= 0) {
        price = price.replace('万', '');
        priceDom = (
          <p className={`price ${this.isAndroid ? 'android' : 'ios'} ${this.isIphone14ProMax ? 'iphone14ProMax' : ''}`}>
            <span className="symbol">¥</span>{price}<span className="suffix">万</span>
          </p>
        )
      } else {
        priceDom = (
          <p className={`price ${this.isAndroid ? 'android' : 'ios'} ${this.isIphone14ProMax ? 'iphone14ProMax' : ''}`}>
            <span className="symbol">¥</span>{price}
          </p>
        )
      }
    }
    return priceDom;
  }

  render() {
    const { componentTemplate, baseConfig } = this.props.config;
    const { showTitle, title, subTitle, titleColor, layout = {}, rankTitleBgImage } = baseConfig;
    if (!componentTemplate) {
      return null;
    }
    return (
      <div
        className="pipeline-rank"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: layout.moduleMarginTop >= 0 ? `${layout.moduleMarginTop}px` : 0,
          marginTop: layout.moduleMarginTop < 0 ? `${layout.moduleMarginTop}px` : 0
        }}
      >
        {baseConfig.imgUrl && (
          <img
            className="rank-banner"
            onClick={this.productBannerGo.bind(this, baseConfig.imgLink)}
            src={utils.formatImgUrl(baseConfig.imgUrl, this.props.webpSupport)}
          />
        )}
        { componentTemplate.templateSelect === '商品榜单一行多' && this.renderProductLayoutMore() }
        { componentTemplate.templateSelect === '商品榜单一行三' && this.renderProductLayoutThree() }
        { componentTemplate.templateSelect === '榜单集合一行二' && this.renderCollectLayoutTwo() }
        { componentTemplate.templateSelect === '榜单集合一行三' && this.renderCollectLayoutThree() }
      </div>
    );
  }
}

export default PipelineRank;



// WEBPACK FOOTER //
// ./components/pipeline-rank/index.jsx